import React, { memo, forwardRef } from "react";
const SvgThereexists = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.4 17.08v4h-6.18c-.267 0-.48.04-.64.12-.16.08-.28.18-.36.3a.904.904 0 00-.18.38c-.027.12-.04.227-.04.32s.013.207.04.34c.027.12.087.24.18.36.08.12.2.22.36.3.16.08.373.12.64.12h7.2c1 0 1.5-.5 1.5-1.5V10.66c0-1-.5-1.5-1.5-1.5H12.6c-.267 0-.48.04-.64.12-.173.08-.3.18-.38.3a.905.905 0 00-.18.38c-.027.12-.04.22-.04.3 0 .08.013.187.04.32.027.12.087.24.18.36.08.12.207.22.38.3.16.08.373.12.64.12h5.8v3.6h-5.48c-.267 0-.48.04-.64.12-.16.08-.28.18-.36.3a.882.882 0 00-.16.34c-.027.12-.04.22-.04.3 0 .08.013.18.04.3.027.12.08.24.16.36.08.107.2.2.36.28.16.08.373.12.64.12h5.48z"
      />
    </svg>
  );
});
SvgThereexists.displayName = "SvgThereexists";
const MemoForwardRef = memo(SvgThereexists);
export default MemoForwardRef;
